import { z } from 'zod';
import type { MacroRecordingInputPayload } from './macroRecording';

export const MACRO_INPUT_DEVICE_IDS = ['mouse', 'keyboard', 'touch', 'gamepad0', 'gamepad1', 'gamepad2', 'gamepad3'] as const;
export type MacroInputDeviceId = typeof MACRO_INPUT_DEVICE_IDS[number];
export const macroInputDeviceSettingsSchema = z.object({
  mouse: z.boolean().default(true), keyboard: z.boolean().default(true), touch: z.boolean().default(true),
  gamepad0: z.boolean().default(true), gamepad1: z.boolean().default(true),
  gamepad2: z.boolean().default(true), gamepad3: z.boolean().default(true),
}).strict();
export type MacroInputDeviceSettings = z.infer<typeof macroInputDeviceSettingsSchema>;

/** Persisted input choices; legacy recordings enable every device. */
export class MacroInputDevicePolicy {
  static defaults(): MacroInputDeviceSettings { return macroInputDeviceSettingsSchema.parse({}); }
  static normalize(settings?: Partial<MacroInputDeviceSettings>): MacroInputDeviceSettings {
    return macroInputDeviceSettingsSchema.parse(settings ?? {});
  }
  static allows(payload: MacroRecordingInputPayload, settings?: MacroInputDeviceSettings): boolean {
    const id = payload.device === 'gamepad' ? `gamepad${payload.deviceId ?? 0}` as MacroInputDeviceId : payload.device;
    return settings?.[id] !== false;
  }
}
